import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getReasonCode,
  getIdReasonCode,
  createReasonCode,
  updateReasonCode,
  deleteReasonCode,
  getMasterUpload,
  createMasterUpload,
  getIdMasterUpload,
  updateMasterUpload,
  deleteMasterUpload,
  updateMasterUploadCancel,
} from "./miscellaneousAPI";

const initialState = {
  data: [],
  dataId: null,
  dataMasterUpload: [],
  dataIdMasterUpload: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  pageNo2: 1,
  pageSize2: 10,
  totalRecord2: 0,
  selected: null,
  result: null,
  permissionReasonCode: [],
  permissionMasterUpload: [],
};

export const fetchReasonCode = createAsyncThunk(
  "ReasonCode/fetchReasonCode",
  async (payload) => {
    const response = await getReasonCode(payload);
    return response;
  }
);

export const addReasonCode = createAsyncThunk(
  "ReasonCode/addReasonCode",
  async (payload) => {
    const response = await createReasonCode(payload);
    return response;
  }
);

export const editReasonCode = createAsyncThunk(
  "ReasonCode/editReasonCode",
  async (payload) => {
    const response = await updateReasonCode(payload);
    return response;
  }
);

export const fetchIdReasonCode = createAsyncThunk(
  "ReasonCode/fetchIdReasonCode",
  async (id) => {
    const response = await getIdReasonCode(id);
    return response;
  }
);

export const removeReasonCode = createAsyncThunk(
  "ReasonCode/removeReasonCode",
  async (payload) => {
    const response = await deleteReasonCode(payload);
    return response;
  }
);

// master upload

export const fetchMasterUpload = createAsyncThunk(
  "MasterUpload/fetchMasterUpload",
  async (payload) => {
    const response = await getMasterUpload(payload);
    return response;
  }
);

export const addMasterUpload = createAsyncThunk(
  "MasterUpload/addMasterUpload",
  async ({ id, file }) => {
    const response = await createMasterUpload(id, file);
    return response;
  }
);
export const editMasterUpload = createAsyncThunk(
  "MasterUpload/editMasterUpload",
  async (payload) => {
    const response = await updateMasterUpload(payload);
    return response;
  }
);
export const prosesUpload = createAsyncThunk(
  "prosesUpload/prosesUpload",
  async (payload) => {
    const response = await updateMasterUpload(payload);
    return response;
  }
);
export const prosesUploadCancel = createAsyncThunk(
  "prosesUpload/prosesUpload",
  async (payload) => {
    const response = await updateMasterUploadCancel(payload);
    return response;
  }
);
export const fetchIdMasterUpload = createAsyncThunk(
  "MasterUpload/fetchIdMasterUpload",
  async (id) => {
    const response = await getIdMasterUpload(id);
    return response;
  }
);

export const removeMasterUpload = createAsyncThunk(
  "MasterUpload/removeMasterUpload",
  async (payload) => {
    const response = await deleteMasterUpload(payload);
    return response;
  }
);

// colormaster

export const miscellaneousSlice = createSlice({
  name: "miscellaneous",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setPermissionReasonCode: (state, action) => {
      state.permissionReasonCode = action.payload;
    },
    setPermissionMasterUpload: (state, action) => {
      state.permissionMasterUpload = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReasonCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReasonCode.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdReasonCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdReasonCode.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addReasonCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(addReasonCode.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editReasonCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(editReasonCode.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(removeReasonCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeReasonCode.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      // master upload

      .addCase(fetchMasterUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMasterUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.dataMasterUpload = action.payload.data.data;
        state.pageNo2 = action.payload.data.pageNo;
        state.pageSize2 = action.payload.data.pageSize;
        state.totalRecord2 = action.payload.data.totalRecord;
      })
      .addCase(fetchIdMasterUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdMasterUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdMasterUpload = action.payload.data.data;
      })

      .addCase(addMasterUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMasterUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editMasterUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMasterUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(prosesUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(prosesUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeMasterUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMasterUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setPermissionMasterUpload,
  setPermissionReasonCode,
} = miscellaneousSlice.actions;

export const selectReasonCode = (state) => state.miscellaneous.data;
export const selectIdReasonCode = (state) => state.miscellaneous.dataId;
export const selectMasterUpload = (state) =>
  state.miscellaneous.dataMasterUpload;
export const selectIdMasterUpload = (state) =>
  state.miscellaneous.dataIdMasterUpload;
export const selectLoading = (state) => state.miscellaneous.loading;
export const selectError = (state) => state.miscellaneous.error;
export const selectPageNo = (state) => state.miscellaneous.pageNo;
export const selectPageSize = (state) => state.miscellaneous.pageSize;
export const selectTotalRecord = (state) => state.miscellaneous.totalRecord;
export const selectPageNo2 = (state) => state.miscellaneous.pageNo2;
export const selectPageSize2 = (state) => state.miscellaneous.pageSize2;
export const selectTotalRecord2 = (state) => state.miscellaneous.totalRecord2;
export const selectSelected = (state) => state.miscellaneous.selected;
export const selectResult = (state) => state.miscellaneous.result;
export const selectPermissionReasonCode = (state) =>
  state.miscellaneous.permissionReasonCode;
export const selectPermissionMasterUpload = (state) =>
  state.miscellaneous.permissionMasterUpload;

export default miscellaneousSlice.reducer;
